/** Moved to `modules/shared/lib/buildKeyMessageHighlightIndex` — see report-utils shim (relative path required for cross-package resolution). */
export * from "../../../shared/lib/buildKeyMessageHighlightIndex";
